var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgotPasswordCuate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.73,
    y: 342.93,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.96,
    y: 357.04,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 357.04,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.79,
    y: 43.84,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.56,
    y: 57.95,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.96,
    y: 43.86,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.56,
    y: 342.85,
    width: 26.48,
    height: 11.19,
    transform: "translate(875.61 696.88) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.34,
    y: 213.9,
    width: 26.48,
    height: 11.19,
    transform: "translate(749.16 439) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.11,
    y: 199.79,
    width: 26.48,
    height: 11.19,
    transform: "translate(778.7 410.78) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.18,
    width: 1,
    height: 107.01,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.84 142.83 126.85 149.4 58.5 149.4 55.52 142.83 84.62 122.69 100.74 122.69 129.84 142.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.76 103.29 100.74 122.69 84.62 122.69 82.6 103.29 102.76 103.29",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.83 142.84 126.84 149.41 58.49 149.41 55.52 142.84 129.83 142.84",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.3,
    width: 1,
    height: 85.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.96 121.64 197.97 128.21 129.62 128.21 126.64 121.64 155.74 101.5 171.86 101.5 200.96 121.64",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.88 82.09 171.86 101.5 155.74 101.5 153.72 82.09 173.88 82.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.96 121.64 197.97 128.21 129.62 128.21 126.64 121.64 200.96 121.64",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.31,431.08c0,13.14-88.78,23.78-198.31,23.78S51.69,444.22,51.69,431.08,140.47,407.3,250,407.3,448.31,417.94,448.31,431.08Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.22,297.73a39.3,39.3,0,0,1-.77,15.16,41.46,41.46,0,0,1-2.32,6.7c-1.21,2.78-2.47,5.48-2.16,8.52.29.19-.71.16-.75-.13-8.11-4.62-18.51-5.47-24.75-13a26,26,0,0,1-5.15-12.64c-.77-4.94-1-10.4.29-15.26C371.68,283,374.09,279,378,277s9.22-1.9,13.42-.6C400.43,279.19,404.94,289,406.22,297.73Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.38,357.76q-1.65-5.53-3.35-11.05c-2.22-7.21-4.53-14.39-7.1-21.49q-2.3-6.37-4.85-12.63a77.33,77.33,0,0,1,1-7.84c.68-3.14,1.66-6.18,2.58-9.25.06-.19-.25-.29-.33-.11-1.82,4.24-4.2,9.66-4.25,14.68q-3-7.08-6.38-13.95A59.5,59.5,0,0,1,388,284.5a.14.14,0,0,0-.27-.05,41.28,41.28,0,0,0-.8,10.25q-2.61-5.16-5.53-10.19c-.18-.3-.59,0-.44.31,3.05,5.87,5.87,11.86,8.53,17.93a38.92,38.92,0,0,0-12.72-7.36c-.2-.08-.35.22-.15.3a46.27,46.27,0,0,1,13.76,9.11q2.85,6.66,5.45,13.44c-5.08-5-12-8.25-18.74-10-.23-.06-.29.29-.07.35,7.78,2.34,13.81,6.75,19.73,12,.68,1.83,1.36,3.66,2,5.49q3.75,10.42,7.15,21,1.64,5,3.22,10.12c1.13,3.64,2,7.48,3.5,11,.14.33.74.26.66-.15A104,104,0,0,0,410.38,357.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.93,290.63a20.31,20.31,0,0,0-2.92,7.28c0,.07.09.11.12,0a62.22,62.22,0,0,1,3.16-7.14C397.42,290.57,397.07,290.42,396.93,290.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.46,307.53a21.28,21.28,0,0,0-7.27-2.45c-.07,0-.11.09,0,.12,1.17.48,2.4.82,3.58,1.28s2.35,1,3.55,1.43A.21.21,0,0,0,382.46,307.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.39,287.21a14.21,14.21,0,0,0-2.34-1.45.13.13,0,0,0-.14.21,14.69,14.69,0,0,0,2.31,1.49C378.37,287.55,378.54,287.3,378.39,287.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.56,325.28c-5.84,1.73-11.71,3.33-17.55,5.05-.51.15-10.38-18.77-6.81-28.52A31.76,31.76,0,0,1,429.05,283c4.17-1.42,9.29-2.61,13.7-1.64,3.92.87,6.68,4.07,8,7.76,1.73,5,1.15,11,.21,16.09a28.09,28.09,0,0,1-5.75,13.13C442.07,322,438.11,323.93,433.56,325.28Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,307.29a76.82,76.82,0,0,1-11.46,4.51,48.24,48.24,0,0,0-7.64,2.77c2.47-5.5,5.17-10.88,8.05-16.22,3.77-1.09,7.74-2.79,10.58-5.46a.16.16,0,0,0-.21-.25c-3.11,2.2-6.55,3.52-10,5,.78-1.44,1.56-2.87,2.36-4.3.22-.4-.32-.79-.59-.41a123.15,123.15,0,0,0-8.3,13.94,63.34,63.34,0,0,1-.6-12.77c0-.11-.15-.12-.17,0a42.63,42.63,0,0,0,.14,14c-2,4.09-3.91,8.28-5.59,12.52-.66-2.55-1.53-5.06-2.11-7.63a35.15,35.15,0,0,1-.84-11.24c0-.11-.15-.12-.17,0A39.69,39.69,0,0,0,418,322.41c-1,2.55-1.91,5.11-2.76,7.68a153,153,0,0,0-7.76,40.52.25.25,0,0,0,.5,0,200.83,200.83,0,0,1,8.7-40c1.69-5.09,3.64-10,5.78-14.89,3.45-1,6.89-2.4,10.28-3.57a32.37,32.37,0,0,0,9.47-4.65A.12.12,0,0,0,442,307.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.47,301.8c-3.57,1.27-7,3.05-10.52,4.34-.17.06-.07.32.09.29,3.78-.78,7.52-1.95,10.57-4.43C447.72,301.91,447.6,301.75,447.47,301.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.3,294.09c.05-.19-.23-.3-.29-.1-1,3.29-1.65,6.79-.7,10.15,0,.13.25.14.25,0C417.73,300.73,417.54,297.43,418.3,294.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.06,286.49a8.78,8.78,0,0,0-1.55,5.6c0,.12.21.19.24.05.44-1.89,1.17-3.6,1.75-5.43A.25.25,0,0,0,433.06,286.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.09,333.62c1.71,5.44,5.78,12.95,12.22,13,4.18,0,8.38-.46,12.57-.52,4.48-.07,9-.06,13.45.21.37,0-.54-13.43-11.31-20-3-1.84-6.71-2.42-10.14-3.16a46.9,46.9,0,0,0-12-1.25c-2.48.1-4.54.62-5.42,3.16S363.26,331,364.09,333.62Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.72,326.82c2.62.67,5.26,1.45,7.89,2.28a29,29,0,0,0-2.17-2.12c-1.13-.93-2.37-1.68-3.58-2.51-.1-.06,0-.26.09-.21a14.73,14.73,0,0,1,6.35,5.06c3.28,1.05,6.52,2.22,9.64,3.5a37,37,0,0,1,6.18,3.25,24.91,24.91,0,0,0-2.24-3.88c-1.43-1.86-3.36-2.89-5.23-4.2a.17.17,0,0,1,.17-.29,15.34,15.34,0,0,1,8.4,9.11,36.22,36.22,0,0,1,6.11,5.55c7.13,8.1,12.75,18.88,12.77,29.87,0,.26-.42.34-.47.06a61,61,0,0,0-13.6-29.2c-.51-.6-1-1.16-1.57-1.71a48.18,48.18,0,0,0-5.89-.44c-2.29,0-4.57.34-6.85.52-3.76.31-7.92.35-11.32-1.54-.15-.08,0-.34.12-.28,7.57,2.75,15.5-.74,23.08.9a35.4,35.4,0,0,0-11.18-7.21l-.7-.28c-4.85.58-10,1.85-14.7.27a.11.11,0,0,1,.06-.22c4.57,1.14,8.95-.3,13.46-.53-4.91-1.91-9.92-3.43-14.84-5.33C368.28,327.08,368.27,326.7,368.72,326.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.58,331.6a66.87,66.87,0,0,0,7.07.54c.05,0,.07.08,0,.09a14.62,14.62,0,0,1-7.13-.45C366.41,331.75,366.47,331.58,366.58,331.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.54,326.94a11.53,11.53,0,0,1,3.5,2.43c.12.11,0,.33-.18.23-.59-.43-1.2-.84-1.82-1.23a19.6,19.6,0,0,1-1.7-1.08A.21.21,0,0,1,382.54,326.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.59,344.44c-.08.17.18.34.28.15h0a.26.26,0,0,0,.17.11,109.12,109.12,0,0,0,13.16,2.3c3.56.32,7.67.51,10.79-1.55,4.23-2.81,7-10.3,4.72-15.06-2.7-5.65-10.85-2.58-14.94-.57A30,30,0,0,0,420.59,344.44Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.43,347.05a41.75,41.75,0,0,1,7.86-6,27,27,0,0,1,8-8.13c.16-.11.29.14.15.25a36.21,36.21,0,0,0-6.72,7.06,73.68,73.68,0,0,1,9.86-4.48,13.15,13.15,0,0,1,5.3-5.31s.1,0,.06.07a21.71,21.71,0,0,0-4.79,5c2-.74,4-1.44,6.05-2.11.18-.06.25.22.08.28-3.6,1.41-7.28,2.89-10.85,4.6a41.67,41.67,0,0,0,13.14,0c.12,0,.17.15,0,.18a25.88,25.88,0,0,1-13.94.21,65.46,65.46,0,0,0-6.61,3.7,16.43,16.43,0,0,1,5.34.44,40.73,40.73,0,0,0,9.39,1.06c.12,0,.15.2,0,.22-5.45.93-10.6-1.54-16-.9a41.31,41.31,0,0,0-5.62,4.6,42,42,0,0,0-8.2,11.57c-2.28,4.63-3.51,9.53-5.35,14.31a.17.17,0,0,1-.33-.09C405.87,364.16,410.56,353.77,417.43,347.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.86,334.12a6.32,6.32,0,0,1,1.4-1.69,5.26,5.26,0,0,1,1.61-1.2c.05,0,.08,0,.05.09-.45.5-1.07.88-1.55,1.36s-.89,1.06-1.38,1.54A.08.08,0,0,1,433.86,334.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.85,337.05c.81-.2,1.66-.19,2.48-.36a22.26,22.26,0,0,0,2.41-.72.1.1,0,0,1,.08.18,8,8,0,0,1-5,1.15C442.72,337.28,442.73,337.08,442.85,337.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.98 361.97 395.69 370.09 398.12 397.51 419.6 397.51 422.63 370.09 423.52 361.97 394.98 361.97",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.98 361.97 395.69 370.09 422.63 370.09 423.52 361.97 394.98 361.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.85,
    y: 359.76,
    width: 32.8,
    height: 6.59,
    transform: "translate(818.51 726.1) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.98 397.44 97.74 397.2 148.49 397.11 250 396.95 351.51 397.11 402.26 397.2 453.01 397.44 402.26 397.69 351.51 397.78 250 397.94 148.49 397.78 97.74 397.69 46.98 397.44",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.23,74.3V398.36c0,9.16-6.86,16.57-15.32,16.57H218.67c-8.48,0-15.34-7.41-15.34-16.57V74.3c0-18.66,6.86-19.57,15.34-19.57H249c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.08,5.83h70.06c3.94,0,7.1,0,7.1-5.83V59.21c0-2.48,1.42-4.48,3.21-4.48h30.29C378.37,54.73,385.23,57.21,385.23,74.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.23,74.3V398.36c0,9.16-6.86,16.57-15.32,16.57H218.67c-8.48,0-15.34-7.41-15.34-16.57V74.3c0-18.66,6.86-19.57,15.34-19.57H249c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.08,5.83h70.06c3.94,0,7.1,0,7.1-5.83V59.21c0-2.48,1.42-4.48,3.21-4.48h30.29C378.37,54.73,385.23,57.21,385.23,74.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.23,74.3l.25,268.6,0,33.57v21a23.28,23.28,0,0,1-.31,4.24,17.6,17.6,0,0,1-3.49,7.7,17.27,17.27,0,0,1-3.07,3,16.43,16.43,0,0,1-3.77,2,14.33,14.33,0,0,1-4.19.85c-1.43.09-2.81,0-4.21.05H349.7l-33.58,0-67.14.07H219.6a18.28,18.28,0,0,1-4.28-.38,15.2,15.2,0,0,1-7.43-4.2,17.32,17.32,0,0,1-4.33-7.36,18.56,18.56,0,0,1-.68-4.25c-.08-1.44,0-2.81,0-4.22v-8.39l.25-268.6,0-33.57V76a69.45,69.45,0,0,1,.38-8.4l.32-2.09.48-2.06c.2-.67.45-1.34.68-2a19.72,19.72,0,0,1,1-1.89,10,10,0,0,1,2.91-3.09,11.69,11.69,0,0,1,4-1.53,47.45,47.45,0,0,1,8.41-.4H248.5a3.65,3.65,0,0,1,1.08.08,2.85,2.85,0,0,1,1,.48A5.07,5.07,0,0,1,252.31,59a13.74,13.74,0,0,0,.37,4.12,3.7,3.7,0,0,0,1,1.71,4,4,0,0,0,1.78.91,18.46,18.46,0,0,0,4.15.27h12.59l33.57,0h16.79c2.8,0,5.6,0,8.39,0a6.12,6.12,0,0,0,3.9-1.13A3.83,3.83,0,0,0,336,63.16a7.86,7.86,0,0,0,.35-2c0-.69,0-1.39,0-2.09a5.89,5.89,0,0,1,.43-2.07,4.1,4.1,0,0,1,1.24-1.7,2.82,2.82,0,0,1,.94-.49,3.8,3.8,0,0,1,1.06-.08h8.39l16.79,0h4.2a30.89,30.89,0,0,1,4.19.23A11.71,11.71,0,0,1,381,58.42,15.58,15.58,0,0,1,384.5,66,45.8,45.8,0,0,1,385.23,74.3Zm0,0a45.82,45.82,0,0,0-.75-8.35A15.6,15.6,0,0,0,381,58.44,11.71,11.71,0,0,0,373.58,55a30.72,30.72,0,0,0-4.18-.21h-4.2l-16.79,0H340a3.92,3.92,0,0,0-1,.09,2.92,2.92,0,0,0-.91.47A4,4,0,0,0,336.89,57c-.58,1.29-.36,2.72-.45,4.12a8.25,8.25,0,0,1-.36,2.08A4,4,0,0,1,335,65a6.2,6.2,0,0,1-4,1.17c-2.81,0-5.6,0-8.4,0H305.8l-33.57,0H259.64a19.2,19.2,0,0,1-4.21-.28,4.33,4.33,0,0,1-1.92-1,4,4,0,0,1-1.11-1.83A14.6,14.6,0,0,1,252,59a4.77,4.77,0,0,0-1.62-3.59,2.93,2.93,0,0,0-.89-.43,4.07,4.07,0,0,0-1-.07H221.22a48.22,48.22,0,0,0-8.34.41,11.55,11.55,0,0,0-3.82,1.48,9.66,9.66,0,0,0-2.79,3c-.36.58-.62,1.23-.93,1.84s-.46,1.31-.65,2l-.48,2-.3,2.06a66.5,66.5,0,0,0-.37,8.35v8.4l0,33.57.25,268.6V395c0,1.39,0,2.82,0,4.18a17.74,17.74,0,0,0,.64,4,16.31,16.31,0,0,0,4.07,7,14.33,14.33,0,0,0,7,4,17.54,17.54,0,0,0,4.06.37H249l67.14.07,33.58,0h16.79c1.39,0,2.81,0,4.17,0a13.75,13.75,0,0,0,4-.81,15.11,15.11,0,0,0,3.62-1.91,16.59,16.59,0,0,0,2.95-2.85,17,17,0,0,0,3.39-7.42,23.64,23.64,0,0,0,.3-4.13v-4.19l0-16.79,0-33.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.23,74.3v38.85H203.33V74.3c0-18.66,6.86-19.57,15.34-19.57H249c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.08,5.83h70.06c3.94,0,7.1,0,7.1-5.83V59.21c0-2.48,1.42-4.48,3.21-4.48h30.29C378.37,54.73,385.23,57.21,385.23,74.3Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.74,62l-.3.29-.16.17a4,4,0,0,0-5.65,0l-.15-.17-.29-.29h0l0,0c.12-.11.24-.22.37-.32a4.54,4.54,0,0,1,2-.93c.19,0,.38,0,.57-.08h.49l.39,0a4.64,4.64,0,0,1,1,.25,4.47,4.47,0,0,1,.7.33,5.46,5.46,0,0,1,.68.47l.31.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.56,63.39l-.46-.46a3.32,3.32,0,0,1,4.71,0l-.46.46a2.68,2.68,0,0,0-3.79,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.89,63.85l-.46.46a1.35,1.35,0,0,0-1-.4,1.34,1.34,0,0,0-1,.4l-.46-.46A2,2,0,0,1,241.89,63.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.87,64.73a.41.41,0,0,1-.41.41.42.42,0,1,1,0-.83A.41.41,0,0,1,240.87,64.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.19,62.89a1.21,1.21,0,1,1,1.21,1.21A1.21,1.21,0,0,1,215.19,62.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,62.89a1.21,1.21,0,1,1,1.2,1.21A1.2,1.2,0,0,1,219,62.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.79,62.89A1.21,1.21,0,1,1,224,64.1,1.2,1.2,0,0,1,222.79,62.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.58,62.89a1.21,1.21,0,1,1,1.21,1.21A1.21,1.21,0,0,1,226.58,62.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.38,62.89a1.21,1.21,0,1,1,1.21,1.21A1.21,1.21,0,0,1,230.38,62.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.59,65.52h-9.82V61h9.82Zm-9.32-.5h8.82V61.48h-8.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.59,
    y: 61.75,
    width: 6.33,
    height: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.59,
    y: 62.04,
    width: 0.87,
    height: 2.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.91 102.47 214.54 97.44 219.91 92.41 220.74 93.29 216.32 97.44 220.74 101.59 219.91 102.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.52,98.13h-1.16v2.05a.53.53,0,0,1-1.05,0V94.61a.52.52,0,0,1,.52-.52h1.69a2,2,0,1,1,0,4Zm-1.16-1h1.16a1,1,0,1,0,0-1.94h-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.52,99.14h-2.29l-.46,1.23a.55.55,0,0,1-.49.33.48.48,0,0,1-.18,0,.53.53,0,0,1-.31-.68l2.08-5.56a.54.54,0,0,1,1,0L278,100a.53.53,0,0,1-.31.68.48.48,0,0,1-.18,0,.53.53,0,0,1-.48-.33Zm-.39-1-.76-2-.77,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.88,99.05a.5.5,0,0,1,.69-.06,3,3,0,0,0,1.8.72,2.11,2.11,0,0,0,1.18-.34.86.86,0,0,0,.4-.68.62.62,0,0,0-.08-.31,1,1,0,0,0-.29-.28,3.62,3.62,0,0,0-1.29-.44h0a5.36,5.36,0,0,1-1.21-.37,2,2,0,0,1-.88-.73,1.48,1.48,0,0,1-.22-.78,1.73,1.73,0,0,1,.76-1.37,2.79,2.79,0,0,1,1.63-.5,3.7,3.7,0,0,1,2,.75.49.49,0,0,1,.14.67.48.48,0,0,1-.67.14,2.75,2.75,0,0,0-1.52-.6,1.8,1.8,0,0,0-1.06.32.76.76,0,0,0-.36.59.45.45,0,0,0,.07.27.88.88,0,0,0,.26.24,3.25,3.25,0,0,0,1.17.42h0a5.22,5.22,0,0,1,1.3.39,2.24,2.24,0,0,1,.95.79,1.5,1.5,0,0,1,.22.8,1.83,1.83,0,0,1-.81,1.46,2.93,2.93,0,0,1-1.74.54,4.06,4.06,0,0,1-2.42-1A.51.51,0,0,1,278.88,99.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.08,99.05a.49.49,0,0,1,.68-.06,3.1,3.1,0,0,0,1.81.72,2.05,2.05,0,0,0,1.17-.34.85.85,0,0,0,.41-.68.54.54,0,0,0-.09-.31.92.92,0,0,0-.28-.28,3.62,3.62,0,0,0-1.29-.44h0a5.2,5.2,0,0,1-1.21-.37,2,2,0,0,1-.88-.73,1.48,1.48,0,0,1-.22-.78,1.73,1.73,0,0,1,.76-1.37,2.77,2.77,0,0,1,1.63-.5,3.7,3.7,0,0,1,2.05.75.49.49,0,0,1-.54.81,2.72,2.72,0,0,0-1.51-.6,1.8,1.8,0,0,0-1.06.32.76.76,0,0,0-.36.59.45.45,0,0,0,.07.27,1,1,0,0,0,.25.24,3.38,3.38,0,0,0,1.18.42h0a5.36,5.36,0,0,1,1.3.39,2.15,2.15,0,0,1,.94.79,1.42,1.42,0,0,1,.23.8,1.83,1.83,0,0,1-.81,1.46,2.93,2.93,0,0,1-1.74.54,4.06,4.06,0,0,1-2.42-1A.5.5,0,0,1,285.08,99.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,94.88l-2.31,5.49a.25.25,0,0,1,0,.09h0l-.05.06s0,0,0,0l-.07,0h0a.17.17,0,0,1-.08.06h0a0,0,0,0,0,0,0l-.07,0h-.23l-.07,0h0a.24.24,0,0,1-.08-.06h0l-.07,0s0,0,0,0l0-.06s0,0,0,0a.25.25,0,0,1,0-.09l-1.23-2.92-1.24,2.92,0,.09a0,0,0,0,0,0,0l-.05.06s0,0,0,0l-.06,0h0l-.07.06h0a0,0,0,0,0,0,0l-.08,0h-.23l-.07,0h0a.24.24,0,0,1-.08-.06h0s0,0-.07,0l0,0-.05-.06h0a.63.63,0,0,0,0-.09L291,94.88a.52.52,0,0,1,1-.4l1.85,4.37,1.22-2.9a.51.51,0,0,1,.49-.32A.55.55,0,0,1,296,96l1.21,2.9,1.84-4.37a.52.52,0,0,1,.69-.27A.5.5,0,0,1,300,94.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,94.91a3.48,3.48,0,0,1,0,4.78,3.11,3.11,0,0,1-2.25,1,3.18,3.18,0,0,1-2.31-1,3.51,3.51,0,0,1,0-4.78,3.13,3.13,0,0,1,2.31-1A3.06,3.06,0,0,1,306.61,94.91Zm-.12,2.39a2.49,2.49,0,0,0-.64-1.65,2,2,0,0,0-3,0,2.39,2.39,0,0,0-.64,1.65,2.33,2.33,0,0,0,.64,1.64,2,2,0,0,0,3,0A2.42,2.42,0,0,0,306.49,97.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,99.91a.52.52,0,0,1-.33.66.79.79,0,0,1-.21,0h0a.76.76,0,0,1-.37-.1,1.06,1.06,0,0,1-.3-.33,2.62,2.62,0,0,1-.19-1.13.77.77,0,0,0-.12-.41.81.81,0,0,0-.28-.27,1.63,1.63,0,0,0-.53-.23h-1.11v2.05a.53.53,0,0,1-.53.52.52.52,0,0,1-.52-.52V94.61a.52.52,0,0,1,.52-.52h1.69a2,2,0,0,1,1.28,3.58,1.38,1.38,0,0,1,.33.35,1.76,1.76,0,0,1,.31,1,2.18,2.18,0,0,0,0,.55A.52.52,0,0,1,313.79,99.91Zm-1.32-3.79a1,1,0,0,0-1-1h-1.16v1.94h1.16A1,1,0,0,0,312.47,96.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.32,100.18V94.61a.52.52,0,0,1,.52-.52H317a3.31,3.31,0,0,1,0,6.61h-1.11A.52.52,0,0,1,315.32,100.18Zm1.05-.53H317a2.26,2.26,0,0,0,0-4.51h-.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.71,271v-4.13a.38.38,0,0,1,.39-.39h2.29a.39.39,0,0,1,.38.39.4.4,0,0,1-.38.39h-1.9v1.28h1.63a.39.39,0,1,1,0,.78h-1.63v1.29h1.9a.39.39,0,0,1,0,.77H229.1A.38.38,0,0,1,228.71,271Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.72,269.37v1.68a.37.37,0,0,1-.38.37.38.38,0,0,1-.37-.37v-1.68a.73.73,0,0,0-.73-.7.71.71,0,0,0-.7.72v1.66a.43.43,0,0,1,0,.05v0l0,.05v0a.39.39,0,0,1-.35.22h-.07a.38.38,0,0,1-.3-.37v-1.66h0V268.3a.37.37,0,0,1,.37-.38.34.34,0,0,1,.33.21,1.54,1.54,0,0,1,.75-.21,1.41,1.41,0,0,1,1.1.49,1.42,1.42,0,0,1,1.1-.49,1.46,1.46,0,0,1,1.46,1.47v1.66a.37.37,0,0,1-.37.37.38.38,0,0,1-.38-.37v-1.66a.72.72,0,0,0-1.43,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.41,269.68v1.37a.37.37,0,0,1-.37.37.38.38,0,0,1-.37-.3,1.62,1.62,0,0,1-2.12-.21,1.78,1.78,0,0,1-.48-1.23,1.77,1.77,0,0,1,.48-1.23,1.62,1.62,0,0,1,1.19-.53,1.6,1.6,0,0,1,.93.31.39.39,0,0,1,.37-.31.38.38,0,0,1,.37.38Zm-.75,0a1,1,0,0,0-.27-.72.86.86,0,0,0-.65-.29.84.84,0,0,0-.65.29,1,1,0,0,0-.27.72,1,1,0,0,0,.27.72.87.87,0,0,0,.65.28.88.88,0,0,0,.65-.28A1,1,0,0,0,241.66,269.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.54,267.05a.37.37,0,0,1-.38.38.38.38,0,0,1-.38-.38v-.15a.38.38,0,0,1,.38-.38.37.37,0,0,1,.38.38Zm0,1.26v2.74a.37.37,0,0,1-.38.37.37.37,0,0,1-.38-.37v-2.74a.37.37,0,0,1,.38-.38A.37.37,0,0,1,244.54,268.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,266.52a.39.39,0,0,1,.39.39V271a.39.39,0,0,1-.77,0v-4.13A.39.39,0,0,1,246,266.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.99,
    y: 276.41,
    width: 132.58,
    height: 11.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.39,282.84a1.74,1.74,0,0,1,1.71-1.75,1.68,1.68,0,0,1,1.69,1.63v0a.17.17,0,0,1,0,.07.34.34,0,0,1-.36.28h-2.23a.86.86,0,0,0,.24.46,1.05,1.05,0,0,0,.67.31,1.19,1.19,0,0,0,.73-.17.37.37,0,0,1,.52,0,.32.32,0,0,1,0,.45,1.77,1.77,0,0,1-3-1.29Zm.76-.34h2a1.15,1.15,0,0,0-1-.74A1,1,0,0,0,232.15,282.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.83,282.54v1.68a.37.37,0,0,1-.37.37.38.38,0,0,1-.38-.37v-1.68a.73.73,0,0,0-.72-.7.71.71,0,0,0-.71.72v1.66a.43.43,0,0,1,0,0v0a.06.06,0,0,1,0,0v0a.39.39,0,0,1-.35.22h-.07a.38.38,0,0,1-.3-.37v-1.66h0v-1.09a.37.37,0,0,1,.37-.38.37.37,0,0,1,.34.21,1.48,1.48,0,0,1,.75-.21,1.44,1.44,0,0,1,1.1.49,1.41,1.41,0,0,1,1.1-.49,1.46,1.46,0,0,1,1.45,1.47v1.66a.37.37,0,0,1-.37.37.38.38,0,0,1-.38-.37v-1.66a.71.71,0,0,0-.7-.72A.73.73,0,0,0,238.83,282.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.52,282.85v1.37a.37.37,0,0,1-.37.37.39.39,0,0,1-.37-.3,1.57,1.57,0,0,1-.93.3,1.61,1.61,0,0,1-1.19-.51,1.78,1.78,0,0,1-.47-1.23,1.76,1.76,0,0,1,.47-1.23,1.63,1.63,0,0,1,1.19-.53,1.57,1.57,0,0,1,.93.31.4.4,0,0,1,.37-.31.38.38,0,0,1,.37.38Zm-.74,0a1,1,0,0,0-.28-.72.87.87,0,0,0-1.3,0,1,1,0,0,0-.27.72,1,1,0,0,0,.27.72.89.89,0,0,0,1.3,0A1,1,0,0,0,244.78,282.85Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.65,280.22a.38.38,0,1,1-.75,0v-.15a.38.38,0,1,1,.75,0Zm0,1.26v2.74a.38.38,0,0,1-.75,0v-2.74a.38.38,0,1,1,.75,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.14,279.69a.4.4,0,0,1,.4.39v4.13a.39.39,0,0,1-.4.38.38.38,0,0,1-.38-.38v-4.13A.39.39,0,0,1,249.14,279.69Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.41,282.85v1.37a.36.36,0,0,1-.37.37.37.37,0,0,1-.36-.3,1.62,1.62,0,0,1-2.12-.21,1.78,1.78,0,0,1-.48-1.23,1.77,1.77,0,0,1,.48-1.23,1.62,1.62,0,0,1,1.19-.53,1.6,1.6,0,0,1,.93.31.38.38,0,0,1,.36-.31.37.37,0,0,1,.37.38Zm-.74,0a1,1,0,0,0-.27-.72.87.87,0,0,0-.65-.29.84.84,0,0,0-.65.29,1,1,0,0,0-.27.72,1,1,0,0,0,.27.72.87.87,0,0,0,.65.28.9.9,0,0,0,.65-.28A1,1,0,0,0,252.67,282.85Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,284.22a.38.38,0,0,1-.38.37.37.37,0,0,1-.37-.3,1.65,1.65,0,0,1-.95.3,1.75,1.75,0,0,1,0-3.5,1.59,1.59,0,0,1,.93.3v-1.32a.39.39,0,0,1,.77,0v2.77h0Zm-1.7-2.36a.89.89,0,0,0-.66.28,1,1,0,0,0-.28.71.94.94,0,0,0,.28.69.88.88,0,0,0,1.31,0,.94.94,0,0,0,.28-.69,1,1,0,0,0-.28-.71A.88.88,0,0,0,256.26,281.86Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.56,281.46a.38.38,0,0,1-.37.38.68.68,0,0,0-.42.13,1,1,0,0,0-.32.33,2.34,2.34,0,0,0-.29.59v1.33a.37.37,0,0,1-.38.37.36.36,0,0,1-.37-.37v-2.76a.36.36,0,0,1,.37-.36.37.37,0,0,1,.38.36v.05a1,1,0,0,1,.15-.14,1.53,1.53,0,0,1,.88-.27A.36.36,0,0,1,261.56,281.46Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.88,282.84a1.74,1.74,0,0,1,1.71-1.75,1.68,1.68,0,0,1,1.69,1.63v0a.17.17,0,0,1,0,.07.34.34,0,0,1-.36.28h-2.23a.93.93,0,0,0,.24.46,1.08,1.08,0,0,0,.67.31,1.19,1.19,0,0,0,.73-.17.39.39,0,0,1,.53,0,.32.32,0,0,1,0,.45,1.77,1.77,0,0,1-1.26.46A1.73,1.73,0,0,1,261.88,282.84Zm.77-.34h2a1.15,1.15,0,0,0-1-.74A1,1,0,0,0,262.65,282.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22,283.59a.37.37,0,0,1,.53,0,1.36,1.36,0,0,0,.77.31.9.9,0,0,0,.47-.14.28.28,0,0,0,.13-.21.14.14,0,0,0,0-.07.24.24,0,0,0-.09-.08,1.67,1.67,0,0,0-.56-.2h0a2.72,2.72,0,0,1-.61-.18,1.12,1.12,0,0,1-.48-.41.81.81,0,0,1-.12-.44,1,1,0,0,1,.41-.77,1.5,1.5,0,0,1,.86-.26,1.73,1.73,0,0,1,1.05.39.39.39,0,0,1,.12.52.38.38,0,0,1-.52.09,1.26,1.26,0,0,0-.65-.25.72.72,0,0,0-.42.12.21.21,0,0,0-.11.16s0,0,0,.06,0,0,.07.07a1.74,1.74,0,0,0,.51.17h0a2.75,2.75,0,0,1,.65.21,1,1,0,0,1,.5.41.94.94,0,0,1,.13.46,1,1,0,0,1-.44.81,1.56,1.56,0,0,1-.91.28,2,2,0,0,1-1.25-.48A.38.38,0,0,1,266.22,283.59Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.6,283.59a.36.36,0,0,1,.52,0,1.36,1.36,0,0,0,.77.31.94.94,0,0,0,.48-.14.26.26,0,0,0,.12-.21.08.08,0,0,0,0-.07s0-.05-.09-.08a1.67,1.67,0,0,0-.56-.2h0a2.72,2.72,0,0,1-.61-.18,1.2,1.2,0,0,1-.49-.41.9.9,0,0,1-.12-.44,1,1,0,0,1,.42-.77,1.48,1.48,0,0,1,.86-.26,1.76,1.76,0,0,1,1.05.39.38.38,0,0,1,.11.52.38.38,0,0,1-.52.09,1.23,1.23,0,0,0-.64-.25.7.7,0,0,0-.42.12.21.21,0,0,0-.11.16.11.11,0,0,0,0,.06.31.31,0,0,0,.08.07,1.64,1.64,0,0,0,.51.17h0a2.75,2.75,0,0,1,.65.21,1,1,0,0,1,.5.41.84.84,0,0,1,.13.46,1,1,0,0,1-.44.81,1.54,1.54,0,0,1-.91.28,2,2,0,0,1-1.24-.48A.37.37,0,0,1,269.6,283.59Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.82,282.14a2.35,2.35,0,0,1-.27,1.12h0a1.5,1.5,0,0,1-.17.25,1.12,1.12,0,0,1-.55.33.55.55,0,0,1-.18,0,.6.6,0,0,1-.53-.26.57.57,0,0,1-.12-.21,1.34,1.34,0,0,1-.63.16,1.3,1.3,0,0,1-1-.42,1.47,1.47,0,0,1-.39-1,1.44,1.44,0,0,1,.39-1,1.31,1.31,0,0,1,1-.43,1.35,1.35,0,0,1,1,.43,1.43,1.43,0,0,1,.38,1v.91l0,0a.53.53,0,0,0,.09-.11,1.7,1.7,0,0,0,.18-.76,1.67,1.67,0,1,0-1.68,1.67,1.87,1.87,0,0,0,.42,0,.38.38,0,0,1,.47.27.4.4,0,0,1-.28.48,2.45,2.45,0,1,1,1.84-2.38Zm-1.87,0a.68.68,0,0,0-.17-.47.57.57,0,0,0-.81,0,.73.73,0,0,0,0,.94.56.56,0,0,0,.4.17.57.57,0,0,0,.41-.17A.68.68,0,0,0,276,282.14Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,282.54v1.68a.37.37,0,0,1-.37.37.38.38,0,0,1-.38-.37v-1.68a.73.73,0,0,0-.72-.7.71.71,0,0,0-.71.72v1.66a.43.43,0,0,1,0,0v0l0,0v0a.39.39,0,0,1-.35.22h-.07a.38.38,0,0,1-.3-.37v-1.66h0v-1.09a.37.37,0,0,1,.37-.38.37.37,0,0,1,.34.21,1.48,1.48,0,0,1,.75-.21,1.44,1.44,0,0,1,1.1.49,1.39,1.39,0,0,1,1.09-.49,1.46,1.46,0,0,1,1.46,1.47v1.66a.37.37,0,0,1-.37.37.38.38,0,0,1-.38-.37v-1.66a.71.71,0,0,0-.71-.72A.73.73,0,0,0,283,282.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.69,282.85v1.37a.37.37,0,0,1-.37.37.39.39,0,0,1-.37-.3,1.57,1.57,0,0,1-.93.3,1.61,1.61,0,0,1-1.19-.51,1.78,1.78,0,0,1-.48-1.23,1.77,1.77,0,0,1,.48-1.23,1.63,1.63,0,0,1,1.19-.53,1.57,1.57,0,0,1,.93.31.4.4,0,0,1,.37-.31.38.38,0,0,1,.37.38Zm-.74,0a1,1,0,0,0-.28-.72.87.87,0,0,0-1.3,0,1,1,0,0,0-.27.72,1,1,0,0,0,.27.72.89.89,0,0,0,1.3,0A1,1,0,0,0,289,282.85Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,280.22a.38.38,0,1,1-.75,0v-.15a.38.38,0,1,1,.75,0Zm0,1.26v2.74a.38.38,0,0,1-.75,0v-2.74a.38.38,0,1,1,.75,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.31,279.69a.4.4,0,0,1,.4.39v4.13a.39.39,0,0,1-.4.38.38.38,0,0,1-.38-.38v-4.13A.39.39,0,0,1,293.31,279.69Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.06,283.6a.53.53,0,0,1,.53.53.53.53,0,0,1-1,0A.53.53,0,0,1,295.06,283.6Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.85,282.85a1.79,1.79,0,0,1,1.78-1.76,1.84,1.84,0,0,1,1.11.39.37.37,0,1,1-.45.59,1.06,1.06,0,0,0-.66-.23,1,1,0,1,0,0,2,1.14,1.14,0,0,0,.66-.22.37.37,0,1,1,.45.59,1.89,1.89,0,0,1-1.11.37A1.77,1.77,0,0,1,295.85,282.85Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.31,284.08a1.7,1.7,0,0,1-.49-1.23,1.78,1.78,0,0,1,.49-1.23,1.65,1.65,0,0,1,1.2-.53,1.59,1.59,0,0,1,1.17.53,1.74,1.74,0,0,1,.49,1.23,1.66,1.66,0,0,1-.49,1.23,1.56,1.56,0,0,1-1.17.54A1.63,1.63,0,0,1,300.31,284.08Zm.28-1.23a1.12,1.12,0,0,0,.25.74.92.92,0,0,0,.67.26.88.88,0,0,0,.64-.26,1.1,1.1,0,0,0,0-1.47,1,1,0,0,0-.64-.26,1,1,0,0,0-.67.26A1.11,1.11,0,0,0,300.59,282.85Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.29,282.54v1.68a.37.37,0,0,1-.37.37.38.38,0,0,1-.38-.37v-1.68a.73.73,0,0,0-.72-.7.71.71,0,0,0-.71.72v1.66a.43.43,0,0,1,0,0v0l0,0v0a.39.39,0,0,1-.35.22h-.07a.38.38,0,0,1-.3-.37v-1.66h0v-1.09a.37.37,0,0,1,.37-.38.37.37,0,0,1,.34.21,1.48,1.48,0,0,1,.75-.21,1.44,1.44,0,0,1,1.1.49,1.39,1.39,0,0,1,1.09-.49,1.46,1.46,0,0,1,1.46,1.47v1.66a.37.37,0,0,1-.37.37.38.38,0,0,1-.38-.37v-1.66a.71.71,0,0,0-.71-.72A.73.73,0,0,0,307.29,282.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.99 238.54 249.06 238.42 264.13 238.38 294.28 238.29 324.42 238.38 339.49 238.42 354.56 238.54 339.49 238.66 324.42 238.71 294.28 238.79 264.13 238.71 249.06 238.66 233.99 238.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.12 245.22 257.41 245.1 269.7 245.06 294.28 244.97 318.86 245.06 331.14 245.1 343.43 245.22 331.14 245.34 318.86 245.39 294.28 245.47 269.7 245.39 257.41 245.34 245.12 245.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.99 310.34 244.56 310.21 261.13 310.17 294.28 310.09 327.42 310.17 344 310.21 360.57 310.34 344 310.46 327.42 310.5 294.28 310.58 261.13 310.5 244.56 310.46 227.99 310.34",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.4,
    y: 327.71,
    width: 103.75,
    height: 16.11,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.87,337.24a1.14,1.14,0,0,0-.51-.95,1.81,1.81,0,0,0-.73-.31l-.05,0h-1.53v2.49a.22.22,0,0,1-.22.22.22.22,0,0,1-.22-.22v-5.87a.21.21,0,0,1,.2-.21h1.8a1.8,1.8,0,0,1,.76,3.42l.09,0a1.59,1.59,0,0,1,.84,1.4,2.59,2.59,0,0,0,.08.73.37.37,0,0,0,.1.16.24.24,0,0,1,.24.14.25.25,0,0,1-.15.29h-.12a.5.5,0,0,1-.41-.29A2.21,2.21,0,0,1,263.87,337.24Zm-1.26-4.43h-1.56v2.72h1.6a1.36,1.36,0,0,0,0-2.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.86,336.47a2.14,2.14,0,0,1,4.27-.16h0v0a.21.21,0,0,1-.22.2h-3.62a1.74,1.74,0,0,0,1.71,1.7,1.64,1.64,0,0,0,1.42-.81.23.23,0,0,1,.29-.07.24.24,0,0,1,.08.31,2.12,2.12,0,0,1-1.79,1A2.17,2.17,0,0,1,265.86,336.47Zm.46-.35h3.34a1.69,1.69,0,0,0-3.34,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.35,337.75a.22.22,0,0,1,.31,0,2.31,2.31,0,0,0,1.35.52,1.26,1.26,0,0,0,.83-.28.66.66,0,0,0,.34-.54.7.7,0,0,0-.32-.54,2.21,2.21,0,0,0-.94-.32h0a2.45,2.45,0,0,1-1-.34.92.92,0,0,1-.48-.79,1.11,1.11,0,0,1,.48-.87,1.9,1.9,0,0,1,1.08-.29,2.38,2.38,0,0,1,1.31.47.24.24,0,0,1,.07.31.21.21,0,0,1-.3.06,2,2,0,0,0-1.08-.44,1.35,1.35,0,0,0-.84.25.68.68,0,0,0-.28.51.54.54,0,0,0,.25.44,2.3,2.3,0,0,0,.9.3h0a3.21,3.21,0,0,1,1.07.36,1.11,1.11,0,0,1,.5.9,1.14,1.14,0,0,1-.51.9,1.8,1.8,0,0,1-1.09.35,2.65,2.65,0,0,1-1.63-.63A.21.21,0,0,1,271.35,337.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.77,336.47a2.14,2.14,0,0,1,4.27-.16h0v0a.21.21,0,0,1-.22.2H276.2a1.74,1.74,0,0,0,1.71,1.7,1.64,1.64,0,0,0,1.42-.81.22.22,0,1,1,.36.24,2.09,2.09,0,0,1-1.78,1A2.17,2.17,0,0,1,275.77,336.47Zm.46-.35h3.34a1.69,1.69,0,0,0-3.34,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.74,334.47a.23.23,0,0,1-.21.22H282v3.21a.35.35,0,0,0,.33.33.22.22,0,0,1,0,.44.75.75,0,0,1-.78-.77v-3.21H281c-.21,0-.21-.11-.21-.22s0-.21.21-.21h.55v-1.64a.24.24,0,0,1,.22-.22.25.25,0,0,1,.23.22v1.64h.57A.22.22,0,0,1,282.74,334.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.6,332.58a.21.21,0,0,1,.22-.21h1.78a1.8,1.8,0,0,1,0,3.59L288,336v2.47a.22.22,0,0,1-.22.22.22.22,0,0,1-.22-.22Zm2,2.95a1.36,1.36,0,0,0,0-2.72H288v2.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.45,334.47v4a.22.22,0,1,1-.43,0v-.66a2,2,0,0,1-1.66.88,2.21,2.21,0,0,1,0-4.41,2.05,2.05,0,0,1,1.66.86v-.65a.21.21,0,0,1,.22-.21A.21.21,0,0,1,296.45,334.47Zm-.43,2a1.66,1.66,0,1,0-1.66,1.78A1.72,1.72,0,0,0,296,336.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,337.75a.21.21,0,0,1,.3,0,2.36,2.36,0,0,0,1.35.52,1.3,1.3,0,0,0,.84-.28.65.65,0,0,0,.33-.54.72.72,0,0,0-.31-.54,2.26,2.26,0,0,0-.94-.32h0a2.56,2.56,0,0,1-1-.34.93.93,0,0,1-.47-.79,1.13,1.13,0,0,1,.47-.87,2,2,0,0,1,1.09-.29,2.41,2.41,0,0,1,1.31.47.22.22,0,0,1,.06.31.2.2,0,0,1-.29.06,2,2,0,0,0-1.08-.44,1.33,1.33,0,0,0-.84.25.68.68,0,0,0-.28.51.54.54,0,0,0,.25.44,2.3,2.3,0,0,0,.9.3h0a3.29,3.29,0,0,1,1.07.36,1.11,1.11,0,0,1,.5.9,1.14,1.14,0,0,1-.51.9,1.83,1.83,0,0,1-1.1.35A2.68,2.68,0,0,1,298,338,.2.2,0,0,1,298,337.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.35,337.75a.22.22,0,0,1,.31,0,2.33,2.33,0,0,0,1.35.52,1.3,1.3,0,0,0,.84-.28.67.67,0,0,0,.33-.54.72.72,0,0,0-.31-.54,2.26,2.26,0,0,0-.94-.32h0a2.56,2.56,0,0,1-1-.34.91.91,0,0,1-.47-.79,1.1,1.1,0,0,1,.47-.87,1.9,1.9,0,0,1,1.08-.29,2.45,2.45,0,0,1,1.32.47.23.23,0,0,1,.06.31.21.21,0,0,1-.3.06,2,2,0,0,0-1.08-.44,1.3,1.3,0,0,0-.83.25.68.68,0,0,0-.28.51.54.54,0,0,0,.25.44,2.24,2.24,0,0,0,.9.3h0a3.29,3.29,0,0,1,1.07.36,1.1,1.1,0,0,1,.49.9,1.13,1.13,0,0,1-.5.9,1.85,1.85,0,0,1-1.1.35,2.68,2.68,0,0,1-1.63-.63A.21.21,0,0,1,302.35,337.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.43,338.63a.15.15,0,0,1-.09-.1l-1.66-3.94a.22.22,0,0,1,.11-.28.21.21,0,0,1,.28.12l1.47,3.47,1-2.42a.23.23,0,0,1,.2-.14.26.26,0,0,1,.22.14l1,2.42,1.45-3.47a.22.22,0,0,1,.28-.12.21.21,0,0,1,.12.28l-1.65,3.92a.23.23,0,0,1-.08.11.16.16,0,0,1-.11.05h0a.22.22,0,0,1-.17-.14h0l-1-2.44-1,2.43v0a.23.23,0,0,1-.19.14l-.08,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.36,334.26a2.21,2.21,0,1,1-2.09,2.2A2.15,2.15,0,0,1,316.36,334.26Zm0,4a1.78,1.78,0,1,0-1.66-1.78A1.73,1.73,0,0,0,316.36,338.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.92,334.48a.22.22,0,0,1,.23-.22.21.21,0,0,1,.2.22v1l.07-.11a2.13,2.13,0,0,1,1.76-1.08.22.22,0,0,1,.22.22.22.22,0,0,1-.22.22,1.6,1.6,0,0,0-1.28.72,4.34,4.34,0,0,0-.53,1,.15.15,0,0,0,0,.08v1.93a.21.21,0,0,1-.2.22.22.22,0,0,1-.23-.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.18,337.81a2.11,2.11,0,0,1-1.69.86,2.21,2.21,0,0,1,0-4.41,2.11,2.11,0,0,1,1.69.86v-2.54a.22.22,0,0,1,.44,0v5.87a.22.22,0,0,1-.44,0Zm0-1.27v-.14a1.76,1.76,0,1,0,0,.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.4,
    cy: 161.72,
    r: 23.17,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.81,
    cy: 195.14,
    r: 15.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.27,157.4V174h-4.7V157.4c0-6.32-4.8-11.46-10.7-11.46s-10.7,5.14-10.7,11.46V174h-4.7V157.4c0-9.05,6.91-16.41,15.4-16.41S307.27,148.35,307.27,157.4Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.47 161.72 281.17 161.91 281.17 174.02 276.47 174.02 276.47 161.72",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.27 162.98 307.27 174.02 302.57 174.02 302.57 162.78 307.27 162.98",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.45,
    y: 164.56,
    width: 42.84,
    height: 38.86,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.87,
    y: 164.56,
    width: 21.42,
    height: 38.86,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.68,185.41l1.8,8.51h-7.62l1.8-8.51a3.81,3.81,0,1,1,4,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.69,381.41a2.53,2.53,0,1,1-2.53-2.54A2.53,2.53,0,0,1,282.69,381.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.11,381.41a3.83,3.83,0,1,1-3.83-3.84A3.84,3.84,0,0,1,298.11,381.41Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.93,381.41a2.54,2.54,0,1,1-2.54-2.54A2.54,2.54,0,0,1,310.93,381.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.83,226.43v-5.32a.49.49,0,0,1,.5-.49h2.94a.5.5,0,0,1,.49.49.51.51,0,0,1-.49.51h-2.44v1.65h2.1a.5.5,0,0,1,0,1h-2.1v2.16a.5.5,0,0,1-.5.49A.49.49,0,0,1,255.83,226.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,226.26a2.26,2.26,0,0,1-.62-1.58,2.39,2.39,0,0,1,.62-1.58,2.12,2.12,0,0,1,1.55-.68,2,2,0,0,1,1.51.68,2.3,2.3,0,0,1,.63,1.58,2.18,2.18,0,0,1-.63,1.58,2,2,0,0,1-1.51.69A2.1,2.1,0,0,1,260.93,226.26Zm.36-1.58a1.42,1.42,0,0,0,.33.95,1.19,1.19,0,0,0,.86.34,1.17,1.17,0,0,0,.83-.34,1.45,1.45,0,0,0,0-1.89,1.26,1.26,0,0,0-.83-.34,1.28,1.28,0,0,0-.86.34A1.43,1.43,0,0,0,261.29,224.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.74,222.9a.48.48,0,0,1-.48.47.89.89,0,0,0-.54.17,1.33,1.33,0,0,0-.41.44,2.6,2.6,0,0,0-.37.75v1.71a.49.49,0,0,1-.5.48.48.48,0,0,1-.48-.48V222.9a.48.48,0,0,1,.48-.47.49.49,0,0,1,.5.47V223a1,1,0,0,1,.18-.18,2,2,0,0,1,1.14-.35A.47.47,0,0,1,268.74,222.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.94,224.7v1.67a2.16,2.16,0,0,1-3.11,1.94.48.48,0,0,1-.21-.65.5.5,0,0,1,.65-.23,1,1,0,0,0,.51.13,1.21,1.21,0,0,0,1.18-1,2.14,2.14,0,0,1-1.18.36,2.05,2.05,0,0,1-1.53-.69,2.22,2.22,0,0,1-.63-1.58,2.34,2.34,0,0,1,.63-1.6,2.11,2.11,0,0,1,1.53-.67,2,2,0,0,1,1.21.38.47.47,0,0,1,.47-.38.48.48,0,0,1,.48.48v1.79Zm-1,0a1.41,1.41,0,0,0-.35-.92,1.12,1.12,0,0,0-.85-.39,1.09,1.09,0,0,0-.83.39,1.32,1.32,0,0,0-.36.92,1.29,1.29,0,0,0,.36.93,1.1,1.1,0,0,0,.83.36,1.13,1.13,0,0,0,.85-.36A1.37,1.37,0,0,0,273,224.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.27,226.26a2.21,2.21,0,0,1-.62-1.58,2.34,2.34,0,0,1,.62-1.58,2.11,2.11,0,0,1,1.55-.68,2,2,0,0,1,1.5.68,2.26,2.26,0,0,1,.63,1.58,2.14,2.14,0,0,1-.63,1.58,2,2,0,0,1-1.5.69A2.08,2.08,0,0,1,276.27,226.26Zm.36-1.58a1.47,1.47,0,0,0,.32.95,1.23,1.23,0,0,0,.87.34,1.19,1.19,0,0,0,.83-.34,1.45,1.45,0,0,0,0-1.89,1.29,1.29,0,0,0-.83-.34,1.33,1.33,0,0,0-.87.34A1.48,1.48,0,0,0,276.63,224.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.33,222.91a.51.51,0,0,1-.5.5h-.22v2.51a.5.5,0,0,1,.49.51.48.48,0,0,1-.49.49,1,1,0,0,1-1-1v-2.51h-.27a.5.5,0,0,1-.49-.5.49.49,0,0,1,.49-.49h.27v-1.31a.5.5,0,0,1,1,0v1.31h.22A.5.5,0,0,1,283.33,222.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.81,224.47h-1.1v2a.5.5,0,0,1-.51.49.49.49,0,0,1-.49-.49v-5.32a.49.49,0,0,1,.49-.49h1.61a1.93,1.93,0,1,1,0,3.85Zm-1.1-1h1.1a.93.93,0,1,0,0-1.85h-1.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.66,224.68v1.76a.47.47,0,0,1-.47.48.48.48,0,0,1-.47-.39,2,2,0,0,1-1.2.39,2.08,2.08,0,0,1-1.53-.66,2.36,2.36,0,0,1,0-3.17,2.09,2.09,0,0,1,1.53-.67,2,2,0,0,1,1.2.4.47.47,0,0,1,.94.09Zm-1,0a1.36,1.36,0,0,0-.35-.93,1.13,1.13,0,0,0-.84-.37,1.11,1.11,0,0,0-.84.37,1.36,1.36,0,0,0-.34.93,1.39,1.39,0,0,0,.34.93,1.17,1.17,0,0,0,.84.35,1.19,1.19,0,0,0,.84-.35A1.4,1.4,0,0,0,295.71,224.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21,225.63a.48.48,0,0,1,.68-.07,1.63,1.63,0,0,0,1,.4,1.22,1.22,0,0,0,.61-.17.39.39,0,0,0,.16-.27.11.11,0,0,0,0-.09.22.22,0,0,0-.11-.11,2.09,2.09,0,0,0-.72-.25h0a3.83,3.83,0,0,1-.79-.24,1.54,1.54,0,0,1-.62-.52,1.08,1.08,0,0,1-.15-.57,1.27,1.27,0,0,1,.53-1,2,2,0,0,1,1.11-.33,2.38,2.38,0,0,1,1.35.49.5.5,0,0,1,.14.67.47.47,0,0,1-.66.13,1.55,1.55,0,0,0-.83-.34.91.91,0,0,0-.54.17c-.12.08-.15.16-.15.2s0,0,0,.07a.22.22,0,0,0,.1.09,1.61,1.61,0,0,0,.66.22h0a3.34,3.34,0,0,1,.83.26,1.37,1.37,0,0,1,.64.53,1.16,1.16,0,0,1,.17.6,1.29,1.29,0,0,1-.56,1,2,2,0,0,1-1.17.36,2.61,2.61,0,0,1-1.61-.62A.49.49,0,0,1,298.21,225.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.55,225.63a.47.47,0,0,1,.67-.07,1.65,1.65,0,0,0,1,.4,1.23,1.23,0,0,0,.62-.17.39.39,0,0,0,.16-.27.11.11,0,0,0,0-.09s0-.07-.12-.11a1.94,1.94,0,0,0-.72-.25h0a3.83,3.83,0,0,1-.79-.24,1.47,1.47,0,0,1-.62-.52,1.08,1.08,0,0,1-.15-.57,1.27,1.27,0,0,1,.53-1,2,2,0,0,1,1.11-.33,2.38,2.38,0,0,1,1.35.49.5.5,0,0,1,.14.67.48.48,0,0,1-.67.13,1.52,1.52,0,0,0-.82-.34.89.89,0,0,0-.54.17c-.12.08-.15.16-.15.2s0,0,0,.07a.22.22,0,0,0,.1.09,1.61,1.61,0,0,0,.66.22h0a3.29,3.29,0,0,1,.84.26,1.42,1.42,0,0,1,.64.53,1.16,1.16,0,0,1,.17.6,1.27,1.27,0,0,1-.57,1,2,2,0,0,1-1.17.36,2.61,2.61,0,0,1-1.6-.62A.48.48,0,0,1,302.55,225.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.85,223.14l-1.49,3.49,0,.08h0l-.05.06h0l-.05,0s0,0,0,0,0,0-.08,0h0l-.07,0h-.21a.11.11,0,0,0-.06,0h0s-.05,0-.08,0h0a.11.11,0,0,1-.05,0h0l0-.06h0a.41.41,0,0,1,0-.08l-.66-1.55-.64,1.55,0,.08h0l-.06.06h0s0,0,0,.05-.06,0-.08,0h0l-.05,0h-.23l0,0h0a.1.1,0,0,1-.08,0s0,0,0,0l-.05,0h0l0-.06h0s0-.06,0-.08l-1.48-3.49a.47.47,0,0,1,.26-.62.45.45,0,0,1,.6.27l1.06,2.42.63-1.5a.48.48,0,0,1,.44-.29.46.46,0,0,1,.44.29l.64,1.5,1.06-2.42a.46.46,0,0,1,.61-.27A.47.47,0,0,1,312.85,223.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,226.26a2.22,2.22,0,0,1-.63-1.58,2.35,2.35,0,0,1,.63-1.58,2.09,2.09,0,0,1,1.54-.68,2,2,0,0,1,1.51.68,2.3,2.3,0,0,1,.63,1.58,2.18,2.18,0,0,1-.63,1.58,2,2,0,0,1-1.51.69A2.06,2.06,0,0,1,315,226.26Zm.36-1.58a1.42,1.42,0,0,0,.32.95,1.21,1.21,0,0,0,.86.34,1.16,1.16,0,0,0,.83-.34,1.45,1.45,0,0,0,0-1.89,1.24,1.24,0,0,0-.83-.34,1.3,1.3,0,0,0-.86.34A1.43,1.43,0,0,0,315.36,224.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8,222.9a.48.48,0,0,1-.48.47.94.94,0,0,0-.54.17,1.44,1.44,0,0,0-.41.44,2.6,2.6,0,0,0-.37.75v1.71a.49.49,0,0,1-.5.48.47.47,0,0,1-.47-.48V222.9a.47.47,0,0,1,.47-.47.49.49,0,0,1,.5.47V223a.81.81,0,0,1,.19-.18,2,2,0,0,1,1.13-.35A.47.47,0,0,1,322.8,222.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.83,226.43a.48.48,0,0,1-.48.49.48.48,0,0,1-.48-.39,2.17,2.17,0,0,1-1.23.39,2.25,2.25,0,0,1,0-4.5,2.1,2.1,0,0,1,1.21.38v-1.7a.49.49,0,0,1,.5-.48.48.48,0,0,1,.48.48v3.57h0Zm-2.19-3a1.17,1.17,0,0,0-.84.37,1.27,1.27,0,0,0-.36.91,1.24,1.24,0,0,0,.36.89,1.15,1.15,0,0,0,1.69,0,1.28,1.28,0,0,0,.36-.89,1.31,1.31,0,0,0-.36-.91A1.17,1.17,0,0,0,325.64,223.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.38,224.35v.58a.43.43,0,0,1-.44.44.44.44,0,0,1-.44-.44V224s0,0,0,0v0a.46.46,0,0,1,.44-.44,1,1,0,1,0,0-2,1,1,0,0,0-.86.5.45.45,0,0,1-.61.16.44.44,0,0,1-.16-.6,1.89,1.89,0,1,1,2.07,2.79Zm0,2v.16a.43.43,0,0,1-.44.44.44.44,0,0,1-.44-.44v-.16a.44.44,0,0,1,.44-.44A.43.43,0,0,1,331.38,226.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "149.48 329.51 151.85 343.74 167.93 430.56 170.52 430.56 158.83 343.74 157.1 329.51 149.48 329.51",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.1 329.51 149.48 329.51 151.85 343.74 158.83 343.74 157.1 329.51",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.99 430.56 101.58 430.56 117.66 343.74 120.03 329.51 112.41 329.51 110.68 343.74 98.99 430.56",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.41 329.51 110.68 343.74 117.66 343.74 120.03 329.51 112.41 329.51",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.77 430.56 53.36 430.56 69.44 343.74 71.81 329.51 64.19 329.51 62.46 343.74 50.77 430.56",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.46 343.74 69.44 343.74 71.81 329.51 64.19 329.51 62.46 343.74",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.88 336.19 172.68 336.19 172.68 323.78 128.58 323.78 113.76 259.14 59.37 259.14 54.88 336.19",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.88 336.19 61.3 336.19 65.49 259.14 59.37 259.14 54.88 336.19",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.78,441.55c-2.22.28-62.87-13.87-64.84-15.78-.24-.21,1.89-11.95,1.89-11.95,1-4.79,17.48-43.82,17.48-43.82L166,379.78,149.16,416s7.56,5.12,14.06,10a0,0,0,0,0,0,0,87.66,87.66,0,0,1,8.22,6.58C173.37,434.94,174,441.29,171.78,441.55Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.93,425.77c2,1.91,62.63,16.06,64.85,15.78s1.59-6.61-.33-8.92a88.19,88.19,0,0,0-8.22-6.57l0,0c-6.49-4.88-14.05-10-14.05-10L152.9,408l-38.42-9.36c-2.91,7.25-5.3,13.49-5.65,15.23C108.83,413.83,106.69,425.56,106.93,425.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,441.72c-2.29.24-63.44-13.46-65.43-15.46-.77-.75.71-9.76,2.81-20.6,0-.11,0-.23.07-.34l39.54,8.4-.16.67s21.05,15.7,23,18.13S174.25,441.49,172,441.72Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.79,439.2c-10.25-2.56-51.83-11.93-62.16-13.69-.08,0-.09,0,0,.06,10.1,2.77,51.76,11.8,62.14,13.8C172,439.41,172,439.25,171.79,439.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.31,414.82c-3.89-1.67-9-2.16-12.73,0-.15.09,0,.29.12.28a58.52,58.52,0,0,1,12.48.2A.27.27,0,0,0,153.31,414.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.84,417.24c-3.88-1.67-9-2.16-12.73,0-.15.09,0,.29.12.28a59.18,59.18,0,0,1,12.48.19A.26.26,0,0,0,155.84,417.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37,419.65c-3.88-1.66-9-2.15-12.73,0-.15.09,0,.29.12.28a58.52,58.52,0,0,1,12.48.19A.27.27,0,0,0,158.37,419.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.57,407.17c-1.1-2.55-4.29-2.23-6.3-1.19a22.12,22.12,0,0,0-8.33,7.88.1.1,0,0,0,.06.16.51.51,0,0,0,.52.65c3.63-.48,7.57-.56,10.94-2.14C159.42,411.6,161.61,409.58,160.57,407.17Zm-8.7,5.64c-1.78.28-3.56.48-5.33.83a66.14,66.14,0,0,1,5-4.5,24.25,24.25,0,0,1,2.67-1.83c1.45-.83,6.75-2.09,5,2.19C158.28,411.86,154,412.47,151.87,412.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.86,410.49c3,2.17,6.89,3,10.36,4.1a.52.52,0,0,0,.64-.54c.06,0,.12-.07.09-.15a22.16,22.16,0,0,0-6.75-9.27c-1.79-1.39-4.87-2.28-6.42,0S134.1,409.22,135.86,410.49Zm-1.18-3.3c-.9-4.52,4.08-2.32,5.36-1.24a23.68,23.68,0,0,1,2.29,2.3,65.51,65.51,0,0,1,4.06,5.32c-1.67-.67-3.39-1.18-5.08-1.78C139.28,411.07,135.18,409.69,134.68,407.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.12,438.21c9.61,2.1,17.06,3.6,17.83,3.52,2.3-.23,1.79-6.79-.16-9.21a87.51,87.51,0,0,0-8-6.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.81,414.7l-42.09-9.92s35.12-80.51,32-84.6c-1.55-2.05-40.74-2.65-53.2-13.21-16.19-13.72-5.33-34.68-5.33-34.68L127,271s-.53,9.14,1.18,10.51c1.12.92,53.27,5.31,59,22.88C194.2,325.94,151.81,414.7,151.81,414.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.79,408.19c-1.1-.52-12-3.72-14.45-4.34-4.92-1.26-9.86-2.5-14.81-3.63-2.59-.59-8.13-1.87-8.47-1.81-.16,0-.19.3,0,.35,4.8,1.58,9.67,2.92,14.54,4.28s21.64,5.39,23.11,5.49C151.82,408.54,152,408.26,151.79,408.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.24,316.55a6.75,6.75,0,0,0-3.3-1l-19-3.17c-5.91-1-11.86-1.87-17.74-3-4.87-.94-9.83-2.21-14-4.85a20.32,20.32,0,0,1-8.61-11.25,36.37,36.37,0,0,1-1.11-14.42c.11-1.18.33-2.35.55-3.51,0-.09-.13-.12-.14,0-1.61,9-1.75,19.36,5,26.51,3.28,3.48,7.78,5.52,12.37,6.85a140.7,140.7,0,0,0,15.92,3.09l19,3.16c3,.51,6.13.9,9.15,1.53a3.15,3.15,0,0,1,1.64.73,2.33,2.33,0,0,1,.27,2.19c-.3,1.49-.71,3-1.13,4.42-3.45,11.77-28.91,71.8-29.59,73.09a.12.12,0,0,0,.21.11c5.8-10.32,24.85-57.57,28.68-68.7a71.16,71.16,0,0,0,2.48-8.66C150,318.53,150.17,317.34,149.24,316.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.38,444.2c-2.12.71-62.82-.14-65.13-1.62-2.53-2.41-3.61-59.68-3.61-59.68l39.05-.32,2.44,41.12s8.43,3.51,15.77,7h0a88.25,88.25,0,0,1,9.36,4.81C234.63,437.4,236.5,443.5,234.38,444.2Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.7,416.78c.58,12.87,1.41,24.74,2.54,25.8,2.31,1.48,63,2.34,65.14,1.62s.25-6.79-2.1-8.67a87.72,87.72,0,0,0-9.37-4.81s0,0,0,0c-7.34-3.49-15.77-7-15.77-7l-.41-6.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.63,444.24c-2.2.73-64.86.43-67.23-1.1-.92-.56-1.41-9.68-1.68-20.72v-.35l40.42-.25v.68s23.93,10.83,26.37,12.78S237.82,443.53,235.63,444.24Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.93,441.81c-10.56-.31-53.19-.56-63.65-.07-.09,0-.09.07,0,.07,10.46.54,53.09.44,63.65.18C235.15,442,235.15,441.82,234.93,441.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.64,422c-4.15-.79-9.24-.18-12.43,2.76-.12.12,0,.29.18.25a58.56,58.56,0,0,1,12.24-2.48A.27.27,0,0,0,211.64,422Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.64,423.77c-4.16-.79-9.24-.18-12.43,2.76-.13.12,0,.29.17.25a58.56,58.56,0,0,1,12.24-2.48A.27.27,0,0,0,214.64,423.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.63,425.59c-4.16-.79-9.24-.18-12.43,2.76-.13.12,0,.29.17.25a58.56,58.56,0,0,1,12.24-2.48A.27.27,0,0,0,217.63,425.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.09,412.93c-1.62-2.26-4.67-1.26-6.41.19a22.14,22.14,0,0,0-6.45,9.47.11.11,0,0,0,.1.15.51.51,0,0,0,.65.52c3.44-1.25,7.27-2.16,10.22-4.43C216.92,417.5,218.63,415.06,217.09,412.93Zm-7.28,7.37c-1.68.66-3.38,1.23-5,1.95a63.37,63.37,0,0,1,3.89-5.45,23.58,23.58,0,0,1,2.21-2.37c1.24-1.12,6.15-3.49,5.4,1.06C215.86,418,211.8,419.52,209.81,420.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.68,421.46c3.41,1.47,7.35,1.42,11,1.79.38,0,.57-.36.51-.67a.11.11,0,0,0,0-.17,22.16,22.16,0,0,0-8.58-7.6c-2.05-1-5.24-1.19-6.26,1.39S191.68,420.6,193.68,421.46Zm-1.87-3c-1.85-4.23,3.49-3.14,5-2.36a24.33,24.33,0,0,1,2.73,1.75,66,66,0,0,1,5.11,4.33c-1.78-.29-3.56-.42-5.35-.65C197.14,421.29,192.83,420.82,191.81,418.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.3,422.29h-44s.55-79.47-2.9-83.87c-4.6-5.88-69-5.75-82.81-24.91-12.4-17.22-1.93-41.58-1.93-41.58l48.77-1.45a101.7,101.7,0,0,1-4.52,15.34s58.74,10.83,75.2,28.82C208.17,326.8,209.3,422.29,209.3,422.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.44,282.49a23.92,23.92,0,0,0-4.13,1.32c-1.4.54-2.78,1.14-4.13,1.8a82.41,82.41,0,0,0-7.71,4.36c-.08,0,0,.15.08.11,2.63-1.37,5.36-2.6,8.09-3.77l3.94-1.7a40.4,40.4,0,0,0,4-1.76A.2.2,0,0,0,130.44,282.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.52,270.47c-.56,2.22-1,4.46-1.69,6.67-.29,1-.58,2-1,3-.32.82-.81,1.77-1.77,1.95s-1.42-.73-1.33-1.64.36-2,.56-3c.23-1.15.47-2.31.68-3.46.1-.58.21-1.16.31-1.74,0-.15.13-1.26.21-1.58,0,0,0,.06.06.05h0s.07,0,.07-.06,0-.11-.06-.17-.06,0-.1,0c-.21.12-.22.41-.29.62-.18.56-.36,1.13-.53,1.69-.31,1.06-.61,2.13-.88,3.2s-.53,2.14-.79,3.21a5,5,0,0,0-.22,2.47,1.9,1.9,0,0,0,1.75,1.43l-.12.21c-.1.22-.17.45-.25.68s-.16.46-.23.69a2.14,2.14,0,0,0-.06.35c0,.13,0,.25,0,.38s.25.32.35.13a3.53,3.53,0,0,1,.21-.32,2.06,2.06,0,0,0,.16-.37c.07-.22.14-.44.19-.67s.13-.45.17-.68a2.71,2.71,0,0,0,0-.41,2.5,2.5,0,0,0,1.29-.49,4.3,4.3,0,0,0,1.33-2c.33-.92.59-1.88.85-2.83a40.69,40.69,0,0,0,1.42-7.16C127.94,270.3,127.58,270.21,127.52,270.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.52,275.91c-.2,1.1-.33,2.22-.59,3.31s-.54,2.14-.89,3.18a11.28,11.28,0,0,1-1.36,2.87,10.72,10.72,0,0,1-2.16,2.2,18.36,18.36,0,0,1-5.23,2.9,24.11,24.11,0,0,1-2.9.85c-.51.12-1,.21-1.55.28a3.26,3.26,0,0,0-1.25.28.26.26,0,0,0,0,.44,4.63,4.63,0,0,0,2.31.07,18.48,18.48,0,0,0,2.47-.43,18,18,0,0,0,4.67-2A14.63,14.63,0,0,0,96,286.7a11,11,0,0,0,2.09-4.57,22.35,22.35,0,0,0,.68-6.2C98.72,275.81,98.54,275.79,98.52,275.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.59,367.17q-.65-10.38-1.72-20.71c-.18-1.7-.35-3.41-.56-5.1a15.67,15.67,0,0,0-.86-3.88c-1-2.59-3.17-3.9-5.78-4.55-3.08-.78-6.27-1.25-9.4-1.75s-6.42-1-9.64-1.43c-6.51-.91-13-1.75-19.51-2.84a154.5,154.5,0,0,1-19.15-4.3c-5.76-1.74-11.67-3.89-16.28-7.88-9.93-8.59-10.29-23-9.08-35,.17-1.7.38-3.39.59-5.09,0-.09-.13-.12-.14,0-.78,6.78-1.7,13.61-1,20.44a33.43,33.43,0,0,0,5.42,15.84c3.36,4.81,8.34,7.92,13.71,10.09a108.07,108.07,0,0,0,18.27,5.25c12.87,2.7,26,3.84,38.95,6.05,1.6.27,3.19.56,4.78.87a20.13,20.13,0,0,1,4.32,1.16c2.94,1.31,3.75,4.17,4.11,7.13.85,6.86,1.42,13.76,1.92,20.66,1,13.89,1.53,27.86,1.51,41.79,0,1.72,0,7.51,0,9.23,0,.15.23.13.23,0C172.65,399.11,172.47,381.1,171.59,367.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.24,415.38c-10-.68-38.66-.4-39-.26-.15.07-.11.34.05.35,5,.36,37.45.53,38.9.27C207.35,415.71,207.41,415.39,207.24,415.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.17,286a164.08,164.08,0,0,1,26.6,5.45,186.28,186.28,0,0,1,25.67,9.29c4.67,2.09,9.19,4.43,13.66,6.89.09.05,0,.18-.08.14a206.19,206.19,0,0,0-25-10.89,202.32,202.32,0,0,0-26-7.54c-5-1.08-10-1.92-15-2.75C121.74,286.48,121.83,285.91,122.17,286Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.07,356.19c-.31-4.78-.81-9.56-1.59-14.3-.32-1.91-.4-4.38-2.41-5.33-.93-.45-19.59-3.69-22.27-3.64a.13.13,0,0,0-.06.24c.25.11,18,3.46,20.24,4a3.54,3.54,0,0,1,2.49,1.3,9.1,9.1,0,0,1,.75,3.07,197.15,197.15,0,0,1,2.48,28.09q.11,3.92.13,7.81c0,2.68-.09,5.39.11,8.05a.22.22,0,0,0,.44,0c.2-2.42.13-4.89.14-7.32s0-4.88,0-7.33C165.51,365.94,165.4,361.06,165.07,356.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.16,226.53c12.61,16.77,42.56,40.35,49.59,34.86,8.64-6.74,7-31.54,7.22-34.73.19-3.41-28.14-2.55-27,.93.67,2.06,1,4.27.45,4.06-1.67-.66-5.38-4-21.47-13C124,213.62,115.81,215.43,124.16,226.53Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,227.49,143.37,234l-8.32,8.16s-9.47-9.18-13.57-16.75c-3-5.57-3.1-10.27-.12-11.29a6.68,6.68,0,0,1,4.44.42C136.53,218.55,150,227.49,150,227.49Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.13,225.79c-2.65,2.42-12.25,11.39-13,13,0,0,.07.12.11.11,1.56-.76,10.62-10.27,13.05-12.9C146.33,225.9,146.18,225.75,146.13,225.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,234l-8.32,8.16s-9.47-9.18-13.57-16.75c-3-5.57-3.1-10.27-.12-11.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,211.49c1.6,5.43.53,17.82-.87,20.71s-22.54,1.78-24.42-.94-5.86-21.42-3.67-26.77S179.32,205.86,181,211.49Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.75,192.32c-.91-2.46-5.35-9.51-7.49-8.69s-.23,6.4.61,8.64c1.75,4.61,1.69,11.42,1.61,14.72s7.63,0,7.63,0S159.13,198.71,156.75,192.32Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.64,211.65s-.3,5.81,2.79,7,4.17-3.46,4.26-3.78c0,.3-.15,5.65,3.09,6.54s3.76-3.9,3.78-4.21c.08.29,1.19,4.17,3.79,4.29,4.49.2,1.93-9.79,3.91-12.84,0,0,5.55,2.77,5.72,2.82,0,0-2.24-9.56-6.49-12a3.13,3.13,0,0,0-3.89.55s-.38-3.16-2.91-3.94c-1.29-.4-3.08,1.32-3.08,1.32a3.92,3.92,0,0,0-2.7-3.07c-1.82-.45-3.58,1.31-4,2.09C154.42,202.43,153.64,211.65,153.64,211.65Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.3,195.94a0,0,0,0,0-.08,0,27.93,27.93,0,0,0-4.66,15.94c0,.18.3.25.33,0A57.14,57.14,0,0,1,158.3,195.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.61,197.33c0-.05-.07-.1-.11,0a26.13,26.13,0,0,0-4,17.71c0,.22.29.37.26.12C160.39,210.9,162.44,202.07,164.61,197.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.78,217.63c-.74-6.06.53-11.75,2.68-17.4,0-.08-.08-.11-.12-.06-1.8,2.49-2.8,6.23-3.32,9.22a16,16,0,0,0,.55,8.27C167.61,217.76,167.8,217.76,167.78,217.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.64,211.65a18.41,18.41,0,0,0,.44,3.32,6.19,6.19,0,0,0,1.39,2.9,2,2,0,0,0,1.31.61,2.9,2.9,0,0,0,1.46-.29,3.56,3.56,0,0,0,1.69-2.38l.59-2.4.28,2.45a9.85,9.85,0,0,0,.87,3.15,3.63,3.63,0,0,0,2.1,2.06,2.06,2.06,0,0,0,2.44-.86,6.2,6.2,0,0,0,.86-3l.18-2.91.78,2.79a9.69,9.69,0,0,0,.94,2.23,3.86,3.86,0,0,0,1.59,1.59,1.83,1.83,0,0,0,1.94-.2,4,4,0,0,0,1.06-2,31.48,31.48,0,0,0,.68-5c.08-.85.16-1.7.28-2.55a6,6,0,0,1,.74-2.45,6.55,6.55,0,0,0-.51,2.48c-.05.84-.06,1.69-.07,2.55a28.19,28.19,0,0,1-.43,5.15,4.84,4.84,0,0,1-1.2,2.48,2.64,2.64,0,0,1-2.86.4,4.77,4.77,0,0,1-2-1.93,10.22,10.22,0,0,1-1.08-2.46l1-.11a7.22,7.22,0,0,1-1,3.55,3,3,0,0,1-1.59,1.25,3.37,3.37,0,0,1-2,0,4.54,4.54,0,0,1-2.67-2.6,11.38,11.38,0,0,1-.9-3.48l.87.06a4.28,4.28,0,0,1-2.24,2.84,3.73,3.73,0,0,1-1.83.27,2.64,2.64,0,0,1-1.64-.86,6.33,6.33,0,0,1-1.29-3.21A15.32,15.32,0,0,1,153.64,211.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,228.2s-15.32-18.52-5.15-21c3-.73,16.3-.1,16.23,2.57-.1,3.44-5.69,4.22-9.28,4.14,0,0,6.1,5.57,3.49,11A6,6,0,0,1,154.45,228.2Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,207.49a12.49,12.49,0,0,1,3.58-.75,28.23,28.23,0,0,1,3.68-.08,42.4,42.4,0,0,1,7.32.88,6.45,6.45,0,0,1,1.83.67,2.53,2.53,0,0,1,.85.73,2,2,0,0,1,.28.55,2.13,2.13,0,0,1,.07.6,3.13,3.13,0,0,1-.83,2,5.94,5.94,0,0,1-1.63,1.18,11.2,11.2,0,0,1-3.66,1,25.63,25.63,0,0,1-3.71.14l.28-.75a14.78,14.78,0,0,1,1.82,2.16,14.25,14.25,0,0,1,1.37,2.44,9.77,9.77,0,0,1,.7,2.7,7.26,7.26,0,0,1-.23,2.75,8.14,8.14,0,0,0-.06-2.7,9.58,9.58,0,0,0-.9-2.52,13.31,13.31,0,0,0-1.44-2.26,15.15,15.15,0,0,0-1.82-1.93l-.83-.71,1.12,0a26.43,26.43,0,0,0,3.57-.25,11,11,0,0,0,3.34-.94c1-.5,1.88-1.32,1.89-2.26s-1.15-1.32-2.25-1.61a33.88,33.88,0,0,0-3.53-.69c-1.19-.19-2.39-.37-3.59-.48A23.31,23.31,0,0,0,148.47,207.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.42,231.65l.83,2.37.8,2.38,1.62,4.73c.54,1.58,1.09,3.15,1.67,4.71.29.78.58,1.56.9,2.33s.65,1.54,1,2.32a32,32,0,0,1-2.41-4.42c-.7-1.53-1.29-3.11-1.85-4.69s-1-3.19-1.45-4.81S154.68,233.31,154.42,231.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.94,283.82c-1.5,1.2-60.89,1.87-61.14,1.45-.68-1.14,15.43-55.32,40.75-72.16,4.46-3,11.26-.91,14.2,1.39,1.48,1.16,5.77,9.93,6.36,17.1S133.89,283.05,132.94,283.82Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,261.56V262c-.28-.17-.57-.36-.84-.56a24.7,24.7,0,0,1-5.5-6c-1.56-2.21-3-4.52-4.38-6.8a62.06,62.06,0,0,0-6.62-9.18l-.31-.33a25.3,25.3,0,0,0-3.2-2.83,17.28,17.28,0,0,0-15.13-2.63,16.44,16.44,0,0,0-6,3.52l.73-1.22a16.34,16.34,0,0,1,5.11-2.76,17.77,17.77,0,0,1,8.1-.5A17.46,17.46,0,0,1,113,236a25.38,25.38,0,0,1,3.48,3.14c.11.12.22.23.32.35a62.92,62.92,0,0,1,6.42,9c1.42,2.29,2.81,4.59,4.35,6.79a24.53,24.53,0,0,0,5.39,5.87C133.19,261.29,133.39,261.43,133.6,261.56ZM128,264.12a20.43,20.43,0,0,1-8.15-2c-5.15-2.45-9.29-6.5-13.42-10.41-1.5-1.42-3-2.84-4.57-4.18l-.25-.22c-.52-.44-1-.87-1.6-1.29a19.82,19.82,0,0,0-7.64-3.9,12.42,12.42,0,0,0-3.33-.3l-.23.4a12,12,0,0,1,3.48.28,19.52,19.52,0,0,1,7.47,3.85c.52.4,1,.81,1.52,1.23a2.75,2.75,0,0,1,.26.22c1.58,1.34,3.09,2.79,4.6,4.22,4.11,3.92,8.27,8,13.5,10.52a20.66,20.66,0,0,0,8.35,2.08,21.63,21.63,0,0,0,5.61-.59c0-.17,0-.33,0-.5A21.56,21.56,0,0,1,128,264.12Zm5.56-14c-.61-1-1.24-2-1.91-3a22.49,22.49,0,0,0-5.62-5.85,13.27,13.27,0,0,0-7.75-2.24c-.59,0-1.17,0-1.76.1l-.56.07a17,17,0,0,0-1.73.32,20.12,20.12,0,0,0-3.81,1.43,46.37,46.37,0,0,0-8.81,6.34c-.11.09-.22.19-.33.27-1.24,1.07-2.49,2.12-3.77,3.11a33.18,33.18,0,0,1-6.83,4.22,22.17,22.17,0,0,1-7.77,1.86c-.42,0-.83,0-1.24,0,0,.09-.08.18-.11.27l1.37-.05a22.48,22.48,0,0,0,7.86-1.86,34.13,34.13,0,0,0,6.91-4.23c1.31-1,2.58-2.07,3.84-3.14l.32-.27a45.08,45.08,0,0,1,8.72-6.24,19.34,19.34,0,0,1,3.74-1.39,15.92,15.92,0,0,1,2-.35l.57,0c.48-.05,1-.07,1.44-.08a13,13,0,0,1,7.53,2.2,22,22,0,0,1,5.5,5.76c.8,1.15,1.54,2.33,2.26,3.54C133.56,250.63,133.56,250.35,133.55,250.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.34,224.79c-3.48-.15-7.67-6.73-8.74-11.39-.07-.32,4.22-11.07,4.85-13.29.13-.45,13,7.34,13,7.34a36.58,36.58,0,0,0-3.76,8.13C131.57,215.9,129.71,224.94,126.34,224.79Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.89,200.23c-.31,3.77-.39,13.79,7.13,16.12a8.71,8.71,0,0,0,1.39.3c.15-.61.24-1,.25-1.08a36.65,36.65,0,0,1,3.76-8.12s0,0,0,0a1,1,0,0,0-.21-.13,0,0,0,0,0,0,0c-.09-.07-.21-.13-.35-.22l-.15-.09c-.08-.06-.18-.11-.28-.17l-.36-.22-.6-.35-.22-.14-.46-.28-1.82-1.08-.69-.41c-.3-.17-.6-.34-.89-.53l-.89-.51-.11-.06-1.51-.88-.5-.29-1-.54-.65-.36-1.28-.68-.29-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,183.4c-3.28,4.24-6,19-3.75,23.43,3.25,6.35,11.19,9.85,17.25,5.35,5.88-4.36,9.08-23.72,6.33-28C142.71,178,131.78,177.14,126.93,183.4Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.79,197.58s-.09,0-.09.07c-.22,1-.64,2.14-1.63,2.25a0,0,0,0,0,0,.06C136.21,200.08,136.75,198.58,136.79,197.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16,196.31c-1.59-.52-2.52,2.69-1,3.18S137.49,196.75,136.16,196.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,198.78s.07.07,0,.11c-.32,1-.53,2.16.27,2.76,0,0,0,.07,0,0C141.73,201.22,142,199.66,142.49,198.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.69,198c1.63.36.8,3.6-.71,3.27S142.32,197.71,143.69,198Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,205.76c.16.31.29.7.63.85a2.6,2.6,0,0,0,1.14.11s.06.05,0,.07a1.41,1.41,0,0,1-1.43.11,1.11,1.11,0,0,1-.48-1.13A.06.06,0,0,1,134,205.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.7,203s-.21,1.55-.4,2.25a15.82,15.82,0,0,0-4.23-.53c-.34,0-.27-.24.14-.35a6.19,6.19,0,0,1,3.65.1c.11-.18.28-2.39.39-2.36a6.29,6.29,0,0,1,1.5.8c.52-3.21.53-6.49,1.1-9.68a.1.1,0,0,1,.19,0,52.2,52.2,0,0,1-.74,10.47C141.25,204.13,140,203.2,139.7,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,193.64c.46-.07.89-.07,1.35-.1a2.24,2.24,0,0,1,1.4.17.7.7,0,0,1,.23.82,1.74,1.74,0,0,1-1.53.85,2.56,2.56,0,0,1-1.78-.42A.74.74,0,0,1,135,193.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.5,194.5a12.35,12.35,0,0,0-1.07-.84,2.18,2.18,0,0,0-1.24-.65.68.68,0,0,0-.65.54,1.72,1.72,0,0,0,.78,1.57,2.52,2.52,0,0,0,1.71.65A.74.74,0,0,0,146.5,194.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.36,196c1.23.47,1.46-2.1,1.52-3a15.9,15.9,0,0,1,.69-2.72,15.06,15.06,0,0,1-1.32,2.48C130.68,193.45,129.13,195.51,130.36,196Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.07,197.6s-2.35-10.42-.19-15.27c1-2.19,4.57-2.68,4.57-2.68a5.4,5.4,0,0,1,3.34-4.61c3.52-1.63,9.82,1.11,9.82,1.11s6.23-4.67,11.37-.28-1,9.85-1,9.85,1.15,3.82-5,4.46c-6,.63-15.82-5.24-15.82-5.24a38.91,38.91,0,0,1-3.84,10.94A3.53,3.53,0,0,1,122.07,197.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.61,176.57a11,11,0,0,0-3.93-2.16,11.7,11.7,0,0,0-4-.67,6.59,6.59,0,0,0-6,3.22,4.62,4.62,0,0,0-.27,3.57c0,.05.09,0,.07,0-.8-2.17.81-4.57,2.7-5.52a9.9,9.9,0,0,1,7-.22,19.21,19.21,0,0,1,4.23,1.92A.07.07,0,0,0,140.61,176.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.28,180.17a5.39,5.39,0,0,0-2.44-4.43,9.13,9.13,0,0,0-5.7-1.68,11.43,11.43,0,0,0-5.74,1.87s0,.09,0,.07a10.12,10.12,0,0,1,10.34-.35,5,5,0,0,1,1.33,8.25,10.37,10.37,0,0,1-5.11,2.55s0,.08,0,.07a10.51,10.51,0,0,0,4.9-2A6,6,0,0,0,154.28,180.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.2,190.9a19.05,19.05,0,0,1-7.91-1.21,38.65,38.65,0,0,1-7.52-3.71c-1.38-.86-2.73-1.78-4.06-2.72,0,0-.08,0,0,.07a42.44,42.44,0,0,0,7.22,5.18,21.28,21.28,0,0,0,7.8,2.52,18,18,0,0,0,4.52-.07S146.24,190.89,146.2,190.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62,195.81s-1.55-5.64-4-5.24-2.41,7.78-.32,9.53A2.59,2.59,0,0,0,125,200Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68,192.68a0,0,0,0,0,0,.06c1.44,1.29,1.77,3.16,1.82,5a1.44,1.44,0,0,0-1.9-1.09s0,.1,0,.1a1.61,1.61,0,0,1,1.47,1.12,8,8,0,0,1,.32,1.62c0,.18.32.2.33,0v0C124.51,197.32,123.91,193.72,121.68,192.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.52,223.67c-2.93,16.36-1.17,50.66,6.28,56.41,8.63,6.65,46.41,8,54.81,5.54,3.35-1-4.62-23.13-8.34-23.1-15.63.11-28.79-1.69-30.13-3.54-2.06-2.83-7.45-22.78-11.13-35.28C114.4,208,108.83,216.33,107.52,223.67Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.24,239.54l-24,15.68a1,1,0,0,0-.15,1.68l11.16,8.38a2.25,2.25,0,0,0,2.41,0l24-15.68a1,1,0,0,0,.15-1.69l-11.16-8.37A2.25,2.25,0,0,0,202.24,239.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.21,238.84l-24,15.68a1,1,0,0,0-.15,1.68l11.16,8.38a2.25,2.25,0,0,0,2.41,0l24-15.68a1,1,0,0,0,.15-1.69l-11.16-8.37A2.25,2.25,0,0,0,201.21,238.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.71,240.15l-22,14.38c-.68.44-.77,1.14-.21,1.56l10,7.49a2.13,2.13,0,0,0,2.24,0l22-14.39c1.38-.89,1.23-1.43.67-1.85l-2-1.5a.52.52,0,0,0-.54.06l-.08,0a.65.65,0,0,1-.9-.07l-4.63-3.47c-.26-.2-.46-.36,0-.64l.07-.05c.19-.12.24-.28.12-.37l-2-1.5C202.84,239.4,202,239.33,200.71,240.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,243.29l1.26,1a.17.17,0,0,0,.17,0h0a.08.08,0,0,0,0-.12l-1.27-.94a.13.13,0,0,0-.16,0h0C207.42,243.21,207.42,243.26,207.46,243.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.49 249.95 197.97 256.31 207.43 250.15 198.94 243.78 189.49 249.95",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.47 253.61 196.42 257.33 196.98 256.96 192.03 253.25 191.47 253.61",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.65 253.52 195.51 257.92 195.79 257.74 189.92 253.34 189.65 253.52",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.14 253.85 195 258.25 195.28 258.07 189.41 253.67 189.14 253.85",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.63 254.19 194.49 258.58 194.77 258.4 188.91 254 188.63 254.19",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.25 247.48 210.31 248.27 210.53 248.12 209.48 247.33 209.25 247.48",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.83 247.75 209.88 248.54 210.11 248.39 209.06 247.6 208.83 247.75",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.41 248.02 209.47 248.82 209.69 248.67 208.64 247.87 208.41 248.02",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.19,250.93a.77.77,0,0,0,0,.39,1.88,1.88,0,0,0,.57,0c.37,0,.65-.24.45-.4s-.47,0-.47,0,.23-.19.06-.31S188.26,250.67,188.19,250.93Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.23 255.83 189.07 260.97 191.26 259.55 184.41 254.41 182.23 255.83",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.41,285.69c1.84,0,17.32-3.84,22-6.47a52.42,52.42,0,0,0,13.46-10.28c6.12-6.56,9.73-11.68,9.85-14.51.13-3.29,0-3.87-12.37,6.22-7,5.7-11.5,5-15.1,3.64-14.8-5.64-29.06-1.79-29.06-1.79S160.33,285.67,167.41,285.69Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.08,264.88c-3.77-1.29,11.17-4.51,12.89-8.72S197,251.8,192.9,253c-14.4,4.27-22.85.77-31.5,6.69-.92.62-3.63,2-3.68,2.44C157.31,266.27,187.08,264.88,187.08,264.88Z",
    style: {
      fill: "rgb(221, 106, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.61,255.59a31.59,31.59,0,0,0-8,.23,19.37,19.37,0,0,0-6.78,2.92c-.09.05,0,.2.08.15,4.44-2.67,9.67-2.93,14.7-3.18A.06.06,0,0,0,177.61,255.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.53,245.6l9.1-1.71,11.46-2.15s-2.69-12.76-6-20.72c-3.38-8.18-9-10.85-12.09.39C104,232.46,104.53,245.6,104.53,245.6Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.34,241.47c3.5-.79,16.35-3.53,18.06-3.26,0,0,.06.13,0,.15-1.51.85-14.5,2.84-18.05,3.32C105.31,241.69,105.27,241.49,105.34,241.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.18,245.29c-.54.16-1.08.3-1.62.44l-.15,0v-.17c-.14-1.43-.16-2.87-.16-4.3s.07-2.87.17-4.3.23-2.86.43-4.28.41-2.83.71-4.24c0,1.44-.1,2.86-.17,4.29s-.16,2.85-.24,4.28c-.15,2.84-.35,5.69-.47,8.54l-.16-.12C105.06,245.4,105.62,245.33,106.18,245.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.78,231.65a16.87,16.87,0,0,1,.64,2.66c.07.45.14.9.18,1.35a12.63,12.63,0,0,1,.07,1.38,10.78,10.78,0,0,1-.74-2.65A11.38,11.38,0,0,1,103.78,231.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.33,241.88l.74-.22-.06.1c-.39-1.19-.7-2.39-1.05-3.58l-.93-3.6c-.6-2.4-1.16-4.8-1.68-7.24a29.44,29.44,0,0,1,1.35,3.48c.41,1.18.73,2.38,1,3.58s.58,2.42.82,3.64.45,2.44.6,3.68v.09h-.08C124.85,241.85,124.59,241.86,124.33,241.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.22,229.75a6.76,6.76,0,0,1,.34,2.08,6.29,6.29,0,0,1-.07,1.06,3.73,3.73,0,0,1-.27,1,14.79,14.79,0,0,1-.16-2.08A9.92,9.92,0,0,1,123.22,229.75Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.3,165.45a6.17,6.17,0,1,1-6.67-5.62A6.16,6.16,0,0,1,176.3,165.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3,165.45a6.43,6.43,0,0,1-5.59,6.92,6.42,6.42,0,1,1-1.11-12.79,6.43,6.43,0,0,1,6.7,5.87Zm0,0a5.91,5.91,0,0,0-6.65-5.37,6,6,0,0,0-5.14,6.39,5.93,5.93,0,0,0,6.16,5.41,5.91,5.91,0,0,0,5.63-6.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,176.82a3.43,3.43,0,1,1-3.72-3.13A3.44,3.44,0,0,1,163,176.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,176.82a3.71,3.71,0,0,1-3.11,4,3.69,3.69,0,1,1,3.11-4Zm0,0a3.27,3.27,0,0,0-1.26-2.28,3.19,3.19,0,1,0,.41,4.74A3.27,3.27,0,0,0,163,176.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,136.76a18,18,0,0,1-24.88,18.77,15.11,15.11,0,0,1-24-.05,11.32,11.32,0,0,1-2,.42A12.26,12.26,0,0,1,160,136.7a18,18,0,0,1,24.26-26.06,15.11,15.11,0,0,1,25.94,4.12,9.59,9.59,0,0,1,1.94-.44,9.88,9.88,0,0,1,8.5,16.47A17.59,17.59,0,0,1,222.44,136.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,136.76a18.28,18.28,0,0,1-1.29,9.22,19.24,19.24,0,0,1-2.37,4.07,18.63,18.63,0,0,1-3.35,3.29,18.19,18.19,0,0,1-17.93,2.33l.17,0a15.38,15.38,0,0,1-24.42.07l.36.12a12.46,12.46,0,0,1-3.84.53,11.88,11.88,0,0,1-3.83-.64,12.69,12.69,0,0,1-6.22-4.55,13.59,13.59,0,0,1-1.77-3.48,13.27,13.27,0,0,1-.64-3.85,12.69,12.69,0,0,1,2.29-7.39V137a18.43,18.43,0,0,1,1-24,18.63,18.63,0,0,1,11.44-5.74,18.35,18.35,0,0,1,12.36,3.13l-.44.07A15.34,15.34,0,0,1,198.44,105a15.31,15.31,0,0,1,11.84,9.77l-.13-.06a10.07,10.07,0,0,1,6.44.08,9.93,9.93,0,0,1,4,16.07v0A17.58,17.58,0,0,1,222.44,136.76Zm0,0a17.64,17.64,0,0,0-1.83-6h0a9.83,9.83,0,0,0-4.07-15.9,9.71,9.71,0,0,0-6.32,0l-.1,0,0-.1a15,15,0,0,0-4.6-6.28,14.74,14.74,0,0,0-7.11-3.13,14.79,14.79,0,0,0-13.88,5.47l-.18.24-.26-.18a17.69,17.69,0,0,0-22.76,2.68,17.69,17.69,0,0,0-.93,22.82l.21.27-.2.29a11.71,11.71,0,0,0-2.15,6.84,12.14,12.14,0,0,0,.57,3.59,12.54,12.54,0,0,0,1.63,3.25,12.08,12.08,0,0,0,5.77,4.31,11.28,11.28,0,0,0,3.6.65,11.45,11.45,0,0,0,3.63-.45l.22-.07.15.19a15.1,15.1,0,0,0,5.16,4.33,14.9,14.9,0,0,0,18.49-4.16l.07-.09.1,0a17.74,17.74,0,0,0,17.75-2.14,18.86,18.86,0,0,0,3.36-3.26,19.07,19.07,0,0,0,2.38-4A18.22,18.22,0,0,0,222.44,136.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.14,136.27l-.57,2.73a2,2,0,0,1-2.48,1.63,2.1,2.1,0,0,1-1.63-2.49l.91-4.37s0,0,.06-.07,0,0,0-.1a2.16,2.16,0,0,1,2.49-1.62,4.81,4.81,0,1,0,2-9.42,4.78,4.78,0,0,0-4.52,1.48,2.11,2.11,0,1,1-3.14-2.81,9,9,0,1,1,6.95,15Zm-1.91,9.2-.16.76a2.06,2.06,0,0,1-2.49,1.63,2.12,2.12,0,0,1-1.63-2.49l.16-.76A2.13,2.13,0,0,1,195.6,143,2.1,2.1,0,0,1,197.23,145.47Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.29,130.72,177,128a2,2,0,0,1,1.83-2.35,2.11,2.11,0,0,1,2.34,1.83l.55,4.43s0,0,0,.09,0,0,.05.08a2.15,2.15,0,0,1-1.83,2.34,4.81,4.81,0,1,0,1.18,9.54,4.72,4.72,0,0,0,3.8-2.84,2.12,2.12,0,0,1,2.8-1.13,2.09,2.09,0,0,1,1.08,2.76,9,9,0,1,1-11.43-12Zm-1.15-9.32-.1-.77a2,2,0,0,1,1.83-2.34,2.09,2.09,0,0,1,2.34,1.83l.1.76a2.14,2.14,0,0,1-1.83,2.35A2.08,2.08,0,0,1,176.14,121.4Z",
    style: {
      fill: "#FFC727"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordCuate);
export default __webpack_public_path__ + "static/media/Forgot-password-cuate.5633bd57989913913b6b7f633ea7ba2d.svg";
export { ForwardRef as ReactComponent };